import React from 'react';
import { getEmbedUrl } from '../../../utils/videoEmbed';

const EmbeddedVideoView = ({ videoUrl }) => {
  return (
    <div className="relative bg-black rounded-lg overflow-hidden">
      <iframe
        src={getEmbedUrl(videoUrl)}
        title="Lesson video"
        className="w-full aspect-video border-0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default EmbeddedVideoView;